import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { connectWalletCardStyles } from './connectWalletCardStyles';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ConnectWalletButton } from '../ConnectWalletButton/ConnectWalletButton';

export interface IConnectWalletCardProps {
  text?: string;
}

export const ConnectWalletCard = ({ text }: IConnectWalletCardProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const classes = connectWalletCardStyles(theme, isDark);
  const { t } = useTranslation();

  return (
    <Grid
      container
      alignItems='center'
      justifyContent='center'
      direction='column'
      sx={classes.container}
    >
      <Paper sx={classes.issuancePaperConnect}>
        <Grid
          item
          container
          direction='column'
          alignItems='center'
          justifyContent='center'
        >
          <Grid item>
            <Typography variant='subtitle2' sx={classes.text}>
              {text ? text : t('vesting.connect_wallet.text')}
            </Typography>
          </Grid>

          <Grid item>
            <ConnectWalletButton />
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
